<div class="mb-24">
  <div class="instances-table max-width-lg pb-20">
    <!-- <div class="mat-display-1 fw-600 mt-30 mb-20">{{'TENANT_MGMT.TENANTS' | transloco}}</div> -->
    <section #loungeCatalogue class="flex flex-col justify-center items-center max-width-lg catalogue-class pb-10">

      <div class="flex flex-row mt-10 w-100-percent">
        <div class="mat-display-2">{{ 'COST_MGMT.TENANT_COST_DETAILS.HEADER' | transloco }}</div>
      </div>

      <div *ngIf="dataLoaded" class="flex flex-row w-100-percent">
        <div class="flex flex-col justify-end w-100-percent mr-30">
          <div *ngIf="dataLoaded" class="flex flex-row w-100-percent">
            <div class="mat-display mr-10">{{ 'COST_MGMT.TENANT_COST_DETAILS.TENANT_NAME' | transloco }} </div>
            <div class="tenant-environment">{{ costMetrics.tenantId }}</div>
          </div>
          <div *ngIf="dataLoaded" class="flex flex-row w-100-percent">
            <div class="mat-display mr-10">{{ 'COST_MGMT.TENANT_COST_DETAILS.SUBSCRIPTION_ID' | transloco }} </div>
            <div class="tenant-status">{{ costMetrics.subscriptionId}}</div>
          </div>
        </div>
      </div>
    </section>
    <div>
      <mat-divider class="mb-12"></mat-divider>
    </div>
    <div *ngIf="dataLoaded" class="mt-10 ml-30 mb-10 w-100-percent">
      <ng-container *ngFor="let costDetails of costMetrics.instanceCostMetric" [ngTemplateOutletContext]="{costDetails: costDetails}"
                    [ngTemplateOutlet]="tenantRow">
      </ng-container>
    </div>
  </div>

</div>
<ng-template #tenantRow let-costDetails="costDetails">
  <div class="tenant-environment">Instance ID : {{ costDetails.instanceId }}</div>

  <div class="mt-10 mb-10 w-100-percent">
    <div class="flex flex-col">
      <div class="flex flex-row mat-subtitle-2 table-head">
        <div [style.max-width.%]="30">{{ 'COST_MGMT.TENANT_COST_DETAILS.RESOURCE_GROUP' | transloco }}</div>
        <div [style.max-width.%]="30">{{ 'COST_MGMT.TENANT_COST_DETAILS.COST' | transloco }}</div>
      </div>
    </div>
    <ng-container *ngFor="let rgCost of costDetails.resourceGroupCost" [ngTemplateOutletContext]="{rgCost: rgCost}"
                  [ngTemplateOutlet]="resourcGroupRow">
    </ng-container>
    <div>
      <mat-divider class="mb-04"></mat-divider>
    </div>
  </div>
</ng-template>

<ng-template #resourcGroupRow let-rgCost="rgCost">
  <div class="flex flex-col table-tr">
    <div class="flex justify-start items-center row-content fw-400">
      <div class="tenant-environment" [style.max-width.%]="30">{{ rgCost.resourceGroupName }}</div>
      <div class="tenant-status" [style.max-width.%]="30">{{ rgCost.cost | number : '1.2-2' }} ({{ rgCost.currencyType }})
      </div>
    </div>
  </div>
</ng-template>
